import React, { FunctionComponent } from 'react'
import { Heading } from '@afterpaytouch/core'

import { AssetChildComponentSpacing, MarginSize } from './types'
import { getSpacingClassName } from './helper'

interface Props extends AssetChildComponentSpacing {
  show?: boolean
  label?: string
}

export const HeroTitle: FunctionComponent<Props> = ({ show = false, label = '', margin, marginTop, marginBottom = MarginSize.x2 }) => {
  if (!show || !label) {
    return null
  }

  return (
    <div className={getSpacingClassName({ margin, marginTop, marginBottom })}>
      <Heading size='L' bold>
        {label}
      </Heading>
    </div>
  )
}
